import type { TranslationShape } from '../types';

export const it = {
  common: {
    loading: 'Caricamento...',
    initializing: 'Inizializzazione...',
    continue: 'Continua',
    back: 'Indietro',
    retry: 'Riprova',
    tryAgain: 'Riprova',
    goBack: 'Torna indietro',
    cancel: 'Annulla',
    close: 'Chiudi',
    closeModal: 'Chiudi finestra',
    closeWindow: 'Chiudi finestra',
    startOver: 'Ricomincia',
    switchToMobile: 'Passa al mobile',
    enableCamera: 'Abilita fotocamera',
    returnToSite: 'Torna al sito',
    notice: 'Avviso',
    done: 'Fatto',
    saving: 'Salvataggio...',
    processing: 'Elaborazione...',
    error: 'Errore',
    moreInfo: 'Ulteriori informazioni',
    productFallback: 'verifica',
  },
  ageEstimateUnavailable: {
    title: 'Non siamo riusciti a verificare la tua età in questo momento',
    description:
      'Si è verificato un problema da parte nostra durante l’analisi del selfie. Puoi riprovare oppure verificarti con il documento usando il selfie appena scattato.',
    descriptionIdOnly:
      'Si è verificato un problema da parte nostra durante l’analisi del selfie. Puoi continuare verificandoti con il documento usando il selfie appena scattato.',
    useId: 'Verifica con documento',
  },
  pipelineRecovery: {
    title: 'La verifica è stata interrotta temporaneamente',
    description:
      'Non è stato possibile continuare questo passaggio. La verifica è ancora attiva.',
    retrying: 'Stiamo riprovando automaticamente. Tieni aperta questa pagina.',
    readyToRetry: 'Riprova quando vuoi.',
    retryingAction: 'Nuovo tentativo…',
  },
  lifecycleRecovery: {
    loadTitle: 'Non è stato possibile caricare il passaggio successivo', loadDescription: 'Controlla la connessione e riprova.', retryTitle: 'Riproviamo',
    retryDescription: 'Questo passaggio è stato interrotto. Riprova.', retrySelfieTitle: 'Rifacciamo il tuo selfie', retrySelfieDescription: 'Guarda la fotocamera con una buona luce e riprova.', retryIdTitle: 'Scattiamo un’altra foto del tuo documento', retryIdDescription: 'Assicurati che il documento sia interamente visibile e leggibile.', restartStepTitle: 'Riproviamo questo passaggio',
    restartStepDescription: 'Dobbiamo ricominciare questo passaggio per continuare.', startAgain: 'Ricomincia', beginAgain: 'Inizia di nuovo',
    cannotContinueTitle: 'Questa verifica non può continuare', cannotContinueDescription: 'Inizia una nuova verifica.', waitingTitle: 'Stiamo completando questo passaggio…',
    waitingDescription: 'Tieni aperta questa pagina. Continueremo automaticamente.', cancelledTitle: 'Verifica annullata', completeTitle: 'Verifica completata',
    closeDescription: 'Puoi chiudere questa finestra.', returnDescription: 'Puoi tornare al sito.', continueTitle: 'Pronto per continuare', continueDescription: 'Continua con il passaggio successivo.',
    rateLimitedTitle: 'Serve un momento', rateLimitedDescription: 'Non possiamo controllare il passaggio successivo in questo momento. La verifica è ancora attiva.', checkStatus: 'Controlla stato',
    finalizingTitle: 'Stiamo finalizzando la verifica…',
    finalizingDescription: 'Tieni aperta questa pagina. Di solito bastano pochi secondi.',
    unconfirmedTitle: 'Stiamo ancora confermando il tuo risultato',
    unconfirmedDescription: 'Ci vuole più tempo del solito. Non dovrai ripetere alcun passaggio.',
    checkAgain: 'Controlla di nuovo',
  },
  footer: {
    terms: 'Termini',
    privacy: 'Privacy',
    biometric: 'Biometria',
    languageLabel: 'Lingua',
    copyright: '© {{year}} {{companyName}}. Tutti i diritti riservati.',
  },
  mainScreen: {
    title: 'Verificati in modo anonimo',
    description:
      'Verifica dell\'eta rapida e privata. Non raccogliamo ne condividiamo mai i tuoi dati.',
    iconAlt: 'Verifica sicura',
    primaryAction: 'Verifica ora',
    secondaryAction: 'Accedi con Emblem',
    separatorText: 'Gia verificato?',
    missingSession:
      'La configurazione della sessione non e disponibile. Avvia di nuovo la verifica dall\'inizio.',
    directAccessBlocked:
      'L\'accesso diretto non e consentito. Avvia di nuovo la verifica dall\'inizio.',
    emblemResumeNotice:
      'L\'accesso con Emblem non e stato completato. Puoi continuare la verifica qui.',
    emblemNoReusableNotice:
      'Non hai ancora un pass Emblem riutilizzabile per questo sito. Puoi continuare la verifica qui.',
  },
  emblemStepUp: {
    title: 'Un altro passaggio di verifica',
    description:
      'La tua passkey Emblem ha funzionato, ma questo sito richiede un livello di verifica piu alto.',
    primaryAction: 'Continua la verifica',
    iconAlt: 'Passaggio aggiuntivo di verifica Emblem',
    detailTitle: 'Cosa succede dopo',
    detailPoint1: 'Completa una rapida verifica per questo sito.',
    detailPoint2:
      'Al termine, la tua passkey Emblem verra aggiornata per futuri siti L2.',
    privacyHint: 'Continui a verificarti in modo privato. I siti ricevono solo il risultato.',
  },
  loading: {
    title: 'Configurazione del sistema di verifica sicuro',
    description: 'I tuoi dati personali non vengono mai raccolti, archiviati o condivisi',
    status: {
      initializing: 'Inizializzazione...',
      settingUpApiKey: 'Configurazione della chiave API...',
      ready: 'Pronto per iniziare la verifica',
      errorRetrying: 'Errore durante l\'inizializzazione - nuovo tentativo...',
    },
    errors: {
      noApiKey: 'Nessuna chiave API configurata. Fornisci una chiave API.',
    },
  },
  cameraAccess: {
    title: 'Accesso alla fotocamera richiesto',
    description: 'L\'accesso alla fotocamera e necessario per verificare la tua eta e continuare',
    continueDesktop: 'Continua su desktop',
    separatorText: 'OPPURE',
    noWebcam: 'Non hai una webcam?',
    privacyNotice: 'La tua immagine viene elaborata all\'istante ed eliminata subito',
    qr: {
      title: 'Continua sul telefono',
      description: 'Scansiona questo codice per completare la verifica su mobile',
      imageAlt: 'Codice QR per la verifica mobile',
      instruction: 'Punta la fotocamera del telefono verso questo codice',
      waiting: 'In attesa di connessione...',
      generating: 'Generazione del codice QR...',
      errorMissingSession: 'ID sessione mancante. Torna indietro e riprova.',
      errorUnavailable: 'Impossibile generare il codice QR. Riprova.',
      errorFailed: 'Generazione del codice QR non riuscita. Riprova.',
    },
  },
  cameraSetup: {
    defaultMessage: 'Posiziona il viso nel cerchio',
    warmup: {
      preparing: 'Preparazione della verifica...',
      preparingDelayed:
        'La connessione al servizio di verifica sta richiedendo più tempo del previsto. Tieni aperta questa pagina.',
      requesting: 'In attesa dell\'autorizzazione alla fotocamera...',
      initializing: 'Avvio della fotocamera...',
      positioning: 'Preparazione del feed della fotocamera...',
      delayed:
        'Sta richiedendo più tempo del previsto. Tieni aperta questa pagina mentre la fotocamera si avvia.',
    },
    analysis: {
      title: 'Elaborazione della foto',
      description: 'Di solito richiede pochi secondi.',
      privacy: 'Le immagini vengono elaborate in modo sicuro e non archiviate.',
      failureMessage: 'Non siamo riusciti a completare il controllo. Riprova.',
    },
    errors: {
      stalledTitle: 'La fotocamera non si è avviata',
      interruptedTitle: 'La fotocamera è stata interrotta',
      missingSessionId: 'ID sessione mancante nel risultato della verifica.',
      faceTimeout:
        'Rilevamento del volto scaduto. Assicurati che il tuo viso sia chiaramente visibile nella fotocamera.',
      faceTimeoutDetail:
        'Nessun volto e stato rilevato entro il tempo richiesto. Riprova e assicurati che il tuo viso sia chiaramente visibile nel cerchio.',
    },
  },
  cameraFeedback: {
    initial_position: 'Centra il viso nell\'inquadratura',
    initial_lighting: 'Trova una buona illuminazione',
    initial_stability: 'Tieni ferma la fotocamera',
    wide_zone_position: 'Centra il viso nell\'inquadratura',
    wide_zone_center: 'Centra il viso nell\'inquadratura',
    wide_too_close: 'Allontanati leggermente',
    wide_off_center: 'Centra il viso nell\'inquadratura',
    wide_movement: 'Rimani fermo',
    wide_gaze: 'Guarda dritto davanti a te',
    wide_success: 'Ottimo posizionamento!',
    zone_transition: 'Perfetto! Ora avvicinati un po\'',
    great_now_move_closer: 'Perfetto! Ora avvicinati un po\'',
    close_zone_position: 'Perfetto! Resta cosi',
    close_zone_gaze: 'Guarda dritto davanti a te',
    close_too_far: 'Avvicinati un po\'',
    close_too_close: 'Allontanati leggermente',
    close_off_center: 'Centra il viso nell\'inquadratura',
    close_movement: 'Rimani fermo',
    close_gaze: 'Guarda dritto davanti a te',
    close_success: 'Perfetto! Resta cosi',
    processing: 'Tutto fatto! Elaborazione...',
    no_face_detected: 'Nessun volto rilevato',
    move_closer: 'Avvicinati un po\'',
    move_further: 'Allontanati leggermente',
    center_face: 'Centra il viso nell\'inquadratura',
    look_at_camera: 'Guarda dritto davanti a te',
    improve_lighting: 'Riproviamo',
    good_position: 'Va bene!',
    move_closer_to_camera: 'Avvicinati un po\'',
    move_further_from_camera: 'Allontanati leggermente',
    good_wide_position: 'Ottimo posizionamento!',
    good_close_position: 'Perfetto! Resta cosi',
  },
  cameraProcessing: {
    verifying: 'Ottimo lavoro! Stiamo elaborando la tua verifica',
    analyzing: 'Analisi...',
  },
  idRequest: {
    l2: {
      title: 'Verifica del documento richiesta',
      description:
        'Fornisci un documento d\'identita rilasciato dal governo per completare la verifica',
    },
    l1: {
      failed: {
        title: 'La scansione non ha potuto confermare la tua eta',
        description: 'Per continuare serve un rapido controllo del documento',
      },
      unavailable: {
        title: 'Concludiamo con un rapido controllo del documento',
        description:
          'Questa volta non siamo riusciti a verificare la tua età dal selfie, quindi useremo il tuo documento.',
      },
      additional: {
        title: 'Verifica aggiuntiva necessaria',
        description:
          'Per garantire la conformita, dobbiamo verificare la tua eta con un documento',
      },
    },
    primaryAction: 'Continua',
    privacyNotice: 'Non archiviamo ne condividiamo i tuoi dati personali',
    privacyTooltip:
      'Il tuo documento viene usato solo per verificare la tua eta. Non viene mai salvato, archiviato o condiviso con il sito richiedente. Il sito richiedente riceve solo una semplice conferma che soddisfi il requisito di eta.',
    iconAlt: 'Documento d\'identita',
  },
  idCapture: {
    errorTitle: 'Acquisizione foto non riuscita',
    initializingTitle: 'Inizializzazione della fotocamera',
    initializingDescription: 'Preparazione dell\'acquisizione del documento...',
    title: 'Scatta una foto del fronte del documento',
    recaptureTitle: 'Non abbiamo potuto accettare questa foto del documento',
    instructions:
      'Assicurati che il documento sia completamente visibile, con testo chiaro e leggibile e tutti i bordi nell\'inquadratura',
    recaptureInstructions:
      'Assicurati che il documento sia nitido e completamente visibile, quindi scatta di nuovo la foto.',
    capturing: 'Acquisizione...',
    recaptureAction: 'Scatta di nuovo la foto',
    captureAction: 'Scansiona documento',
    capturedTitle: 'Foto acquisita!',
    capturedDescription: 'Preparazione per la revisione...',
    cameraErrorTitle: 'Errore fotocamera',
    cameraErrorAlt: 'Errore fotocamera',
    cameraRecoveryDescription:
      'Riprova, cambia fotocamera se disponibile oppure verifica che questo browser sia autorizzato a usare la fotocamera.',
    cameraPermissionHelp:
      'Su iPhone o iPad, controlla l’accesso alla fotocamera per Safari in Impostazioni. In Chrome o Safari, usa l’icona della fotocamera nella barra degli indirizzi per consentire l’accesso.',
    switchCameraAction: 'Cambia fotocamera',
  },
  idReview: {
    title: 'Controlla il documento scansionato',
    description: 'Assicurati che tutte le informazioni siano chiaramente visibili',
    imageAlt: 'Documento acquisito',
    guidance: 'Il documento deve essere visibile e leggibile.',
    missingImage: 'Nessuna immagine acquisita. Torna indietro e acquisisci il documento.',
    submitAction: 'Continua',
    retakeAction: 'Rifai',
  },
  idProcessing: {
    title: 'Verifica del documento',
    description:
      'Questo processo di solito richiede circa 20-30 secondi. In alcuni casi puo richiedere fino a 60 secondi.',
    keepOpen: 'Tieni aperta questa pagina mentre la verifica viene completata.',
    info: 'Il tuo documento viene elaborato in modo sicuro e nessun dato personale viene archiviato.',
    status: {
      initial: 'Verifica in corso.',
      stillWorking: 'Stiamo ancora verificando il documento...',
      almostDone: 'Quasi fatto. Grazie per la pazienza.',
    },
    steps: {
      received: 'Documento ricevuto',
      analyzing: 'Analisi delle informazioni',
      verifying: 'Verifica dell\'autenticita',
      confirming: 'Conferma dell\'eta',
    },
    errors: {
      noDocumentData: 'Nessun dato del documento trovato. Acquisisci di nuovo il documento.',
      noSessionId: 'Nessun ID sessione disponibile. Riavvia il processo di verifica.',
      selfieFetchFailed:
        'Impossibile recuperare il selfie dal server. Riavvia il processo di verifica.',
      noApiKey:
        'Chiave API non disponibile. Aggiorna la pagina e riavvia il processo di verifica.',
      generic: 'Verifica non riuscita.',
    },
  },
  desktopWaiting: {
    title: 'Dispositivo connesso',
    description: 'Completa la verifica sul tuo dispositivo mobile',
    iconAlt: 'Dispositivo mobile',
    keepOpen: 'Tieni aperta questa finestra',
    redirectInfoLine1: 'Verrai reindirizzato automaticamente quando',
    redirectInfoLine2: 'la verifica sara completata.',
    expiredTitle: 'Sessione scaduta',
    expiredDescription: 'La tua sessione di verifica e scaduta. Ricomincia.',
  },
  returnToDesktop: {
    title: 'Torna al desktop',
    description:
      'Verifica mobile completata. Torna al browser desktop per continuare.',
    iconAlt: 'Computer desktop',
  },
  recovery: {
    title: 'Continuare la verifica?',
    description: 'Abbiamo trovato una sessione di verifica in corso',
    lastSeen: 'Ultima attivita: {{screen}}',
    progressLine: '{{age}} • {{progress}}',
    progress: {
      start: 'Appena iniziata',
      early: 'All\'inizio del processo',
      good: 'Buon avanzamento',
      halfway: 'Oltre meta percorso',
      almost: 'Quasi finita',
      nearlyComplete: 'Quasi completa',
    },
    time: {
      minuteAgo: '{{count}} minuto fa',
      minutesAgo: '{{count}} minuti fa',
      secondAgo: '{{count}} secondo fa',
      secondsAgo: '{{count}} secondi fa',
    },
    screens: {
      main: 'Benvenuto',
      emblemStepUp: 'Passaggio aggiuntivo Emblem',
      cameraSetup: 'Configurazione fotocamera',
      verification: 'Verifica dell\'eta',
      idRequest: 'Documento richiesto',
      idCapture: 'Acquisizione documento',
      idProcessing: 'Elaborazione documento',
      idReview: 'Revisione acquisizione',
      success: 'Verifica completata',
      failure: 'Verifica non riuscita',
      error: 'Errore tecnico',
      unknown: '{{screenName}}',
    },
    actions: {
      continue: 'Continua da dove eri rimasto',
      startFresh: 'Ricomincia',
    },
    capabilities: {
      connection: '✓ La connessione puo essere ripristinata',
      camera: '✓ Impostazioni fotocamera salvate',
      manual: 'Potrebbe essere necessario riconfigurare alcune impostazioni',
    },
    info: {
      continuingLabel: 'Continuazione:',
      continuingDescription: 'Riprendi la verifica da dove eri rimasto.',
      startFreshLabel: 'Nuovo inizio:',
      startFreshDescription: 'Inizia una nuova sessione di verifica.',
    },
  },
  errorScreen: {
    helpTitle: 'Cosa puoi fare:',
    invalidSession: {
      title: 'Sessione non valida',
      description:
        'La sessione di verifica non e valida o e scaduta. Prova ad avviare di nuovo il processo di verifica.',
      primaryAction: 'Contatta il supporto',
      suggestion1: 'Torna al sito del commerciante',
      suggestion2: 'Avvia di nuovo il processo di verifica',
      suggestion3: 'Contatta il supporto se il problema persiste',
    },
    expiredSession: {
      title: 'Sessione scaduta',
      description:
        'La tua sessione di verifica è scaduta. Torna al sito o all’app in cui hai iniziato.',
      primaryAction: 'Torna al sito',
      suggestion1: 'Torna al sito o all’app in cui hai iniziato',
      suggestion2: 'Avvia lì una nuova verifica',
      suggestion3: 'Contatta il sito se hai bisogno di aiuto',
    },
    network: {
      title: 'Problema di connessione',
      description:
        'Impossibile connettersi ai servizi di verifica. Controlla la connessione internet e riprova.',
      suggestion1: 'Controlla la connessione internet',
      suggestion2: 'Disattiva la VPN se la stai usando',
      suggestion3: 'Prova ad aggiornare la pagina',
      suggestion4: 'Contatta il supporto se il problema persiste',
    },
    unsupported: {
      title: 'Browser non supportato',
      description:
        'Il tuo browser non supporta le funzionalita richieste per la verifica dell\'eta. Usa un browser moderno come Chrome, Firefox o Safari.',
      primaryAction: 'Scarica Chrome',
      suggestion1: 'Aggiorna il browser attuale',
      suggestion2: 'Prova a usare Chrome, Firefox o Safari',
      suggestion3: 'Abilita JavaScript se e disattivato',
    },
    cameraDenied: {
      title: 'Accesso alla fotocamera richiesto',
      description:
        'La verifica dell\'eta richiede l\'accesso alla fotocamera. Consenti i permessi della fotocamera e riprova.',
      suggestion1: 'Fai clic sull\'icona della fotocamera nella barra degli indirizzi',
      suggestion2: 'Seleziona "Consenti" per l\'accesso alla fotocamera',
      suggestion3: 'Aggiorna la pagina dopo aver concesso il permesso',
    },
    missingReturnUrl: {
      title: 'Errore di configurazione',
      description:
        'Alla sessione di verifica manca una configurazione richiesta. Contatta il commerciante per correggere l\'integrazione.',
      primaryAction: 'Contatta il commerciante',
      suggestion1: 'Torna al sito del commerciante',
      suggestion2: 'Contatta il team di supporto del commerciante',
      suggestion3: 'Segnala che la loro integrazione {{productName}} deve essere aggiornata',
      suggestion4:
        'Il commerciante deve fornire un URL di ritorno valido nella configurazione SDK',
    },
    directAccess: {
      title: 'Accesso diretto non consentito',
      description:
        'La verifica dell\'eta deve essere aperta tramite il sito di un commerciante usando l\'SDK {{productName}}. Non puoi accedere direttamente a questo servizio.',
      primaryAction: 'Chiudi pagina',
      iconAlt: 'Accesso bloccato',
      suggestion1: 'Torna al sito del commerciante da cui hai iniziato',
      suggestion2:
        'Completa la verifica dell\'eta tramite il loro checkout o processo di registrazione',
      suggestion3: 'Non aggiungere ai segnalibri ne condividere questo URL di verifica',
      suggestion4:
        'Ogni sessione di verifica e unica e deve essere avviata dal commerciante',
    },
    subscriptionRequired: {
      title: 'Abbonamento richiesto',
      description:
        'Questo account richiede un abbonamento attivo per eseguire verifiche in produzione. Contatta l\'amministratore per aggiornare il piano.',
      primaryAction: 'Contatta l\'amministratore',
      portalAction: 'Apri portale di fatturazione',
    },
    planLimitReached: {
      title: 'Limite mensile raggiunto',
      description:
        'Questo account ha raggiunto il limite mensile di verifiche. Contatta l\'amministratore per aggiornare il piano o attendi il prossimo periodo di fatturazione.',
      primaryAction: 'Contatta l\'amministratore',
      portalAction: 'Apri portale di fatturazione',
    },
    sandboxLimitReached: {
      title: 'Limite sandbox raggiunto',
      description:
        'Questo account ha raggiunto il limite di verifiche demo/test. E richiesto un abbonamento a pagamento per continuare con verifiche in produzione.',
      primaryAction: 'Contatta l\'amministratore',
      portalAction: 'Apri portale di fatturazione',
    },
  },
  failure: {
    genericError: 'Verifica non riuscita',
    iconAlt: 'Verifica non riuscita',
    document: {
      title: 'Verifica non riuscita',
      description: 'Non siamo riusciti a completare la verifica. Riproviamo.',
      reason1: 'Problemi di qualita dell\'immagine del documento',
      reason2: 'Informazioni non chiaramente visibili',
      reason3: 'Tipo di documento non supportato',
      reason4: 'Requisiti di verifica dell\'eta non soddisfatti',
    },
    face: {
      title: 'Verifica non riuscita',
      description: 'Non siamo riusciti a completare la verifica. Riproviamo.',
      reason1: 'Il controllo di vitalita non e stato superato',
      reason2: 'Condizioni di illuminazione insufficienti',
      reason3: 'Problemi di posizionamento della fotocamera',
      reason4: 'Movimento durante la scansione',
      reason5: 'Volto non chiaramente visibile',
    },
    crossDeviceRestart: {
      title: 'Torna al desktop',
      description:
        'Questa verifica deve essere riavviata dal browser desktop che mostrava il codice QR. Torna li, fai clic su Riprova e scansiona il nuovo codice QR con il telefono.',
    },
    errors: {
      restartFailed:
        'Riavvio della verifica non riuscito. Aggiorna la pagina e riprova.',
      switchFailed: 'Passaggio al mobile non riuscito. Aggiorna la pagina e riprova.',
    },
  },
  success: {
    title: 'Verifica dell\'eta riuscita',
    emblemTitle: 'Account Emblem creato!',
    emblemDescription:
      'La tua verifica dell\'eta portatile e pronta. Puoi usare il tuo account Emblem per verificare la tua eta su qualsiasi sito che supporti Emblem.',
    iconAlt: 'Successo',
    continueAction: 'Continua al sito',
    separatorText: 'salta le verifiche future',
    createEmblemAction: 'Crea account Emblem',
    emblemEnrollmentComplete: 'Account Emblem creato',
    readyDescription: 'Ora puoi accedere ai contenuti',
    redirectingIn: 'Reindirizzamento tra {{seconds}} secondi...',
    returnUrlInvalid:
      'L\'URL di ritorno non e configurato o non e valido. Fai clic su Continua per procedere.',
    errors: {
      missingReturnUrl: 'URL di ritorno mancante - configurazione SDK del commerciante errata',
      emblemSignupFailed: 'Creazione dell\'account Emblem non riuscita',
    },
  },
  emblem: {
    info: {
      ariaLabel: 'Scopri di piu su Emblem',
      trigger: 'Cos\'e Emblem?',
      title: 'Cos\'e Emblem?',
      paragraph1:
        'Emblem salva in modo sicuro la tua verifica dell\'eta, permettendoti di dimostrare che hai piu di 18 anni senza condividere dati personali.',
      paragraph2:
        'Dopo aver verificato la tua eta tramite {{productName}}, puoi creare un account Emblem per saltare verifiche future sui siti aderenti. La tua verifica resta privata; i siti sapranno solo che sei verificato, nient\'altro.',
      linkLabel: 'Sito web di Emblem',
    },
    signupInfo: {
      ariaLabel: 'Scopri di piu sulla creazione di un account Emblem',
      trigger: 'Perche creare un account?',
      title: 'Crea un account Emblem',
      intro: 'Salva la tua verifica per usi futuri! Con un account Emblem puoi:',
      bullet1: 'Saltare verifiche dell\'eta future sui siti aderenti',
      bullet2: 'Mantenere privati i tuoi dati personali',
      bullet3: 'Accedere subito ai contenuti con restrizioni di eta',
      outro:
        'La tua verifica viene archiviata in modo sicuro. I siti sapranno solo che sei verificato, nient\'altro su di te.',
      linkLabel: 'Sito web di Emblem',
    },
  },
  mobileCompletion: {
    title: 'Verifica completata',
    description:
      'La verifica mobile e stata completata correttamente. Puoi chiudere questa finestra e tornare al desktop.',
    iconAlt: 'Computer desktop',
    closeWindowFallback:
      'Chiudi manualmente questa scheda/finestra per tornare al desktop.',
  },
  cameraErrorBoundary: {
    iconAlt: 'Errore fotocamera',
    trySteps: 'Prova questi passaggi:',
    skipCamera: 'Continua senza fotocamera',
    permission: {
      title: 'Accesso alla fotocamera richiesto',
      description: 'Per verificare la tua eta, abbiamo bisogno di accedere alla fotocamera.',
      step1: 'Fai clic sull\'icona della fotocamera nella barra degli indirizzi del browser',
      step2: 'Seleziona "Consenti" per l\'accesso alla fotocamera',
      step3: 'Fai clic su "Riprova" qui sotto',
    },
    notFound: {
      title: 'Nessuna fotocamera rilevata',
      description: 'Non siamo riusciti a trovare una fotocamera sul tuo dispositivo.',
      step1: 'Controlla che la fotocamera sia collegata correttamente',
      step2: 'Prova a usare un altro browser',
      step3: 'Usa un dispositivo con fotocamera integrata',
    },
    inUse: {
      title: 'Fotocamera in uso',
      description: 'La fotocamera e usata da un\'altra applicazione.',
      step1: 'Chiudi altre app che potrebbero usare la fotocamera',
      step2: 'Controlla eventuali videochiamate o software di registrazione',
      step3: 'Riavvia il browser e riprova',
    },
    unsupported: {
      title: 'Browser non supportato',
      description: 'Il tuo browser non supporta l\'accesso alla fotocamera.',
      step1: 'Aggiorna il browser all\'ultima versione',
      step2: 'Prova a usare Chrome, Firefox, Safari o Edge',
      step3: 'Abilita WebRTC nelle impostazioni del browser',
    },
    default: {
      title: 'Errore fotocamera',
      description: 'Abbiamo riscontrato un problema nell\'accesso alla fotocamera.',
      step1: 'Controlla la connessione della fotocamera',
      step2: 'Aggiorna la pagina e riprova',
      step3: 'Prova a usare un altro browser',
    },
    platform: {
      chrome: 'Chrome/Edge:',
      chromeInstruction: 'Fai clic sull\'icona della fotocamera nella barra degli indirizzi',
      firefox: 'Firefox:',
      firefoxInstruction: 'Fai clic sull\'icona dei permessi accanto all\'URL',
      safari: 'Safari:',
      safariInstruction: 'Vai su Safari -> Impostazioni -> Siti web -> Fotocamera',
    },
  },
  verificationErrorBoundary: {
    iconAlt: 'Errore',
    retryAttempt: 'Tentativo {{attempt}} di {{max}}',
    errorDetails: 'Dettagli errore',
    errorType: 'Tipo di errore:',
    errorTypeGeneral: 'generale',
    componentStack: 'Stack componente:',
    cameraDenied: {
      title: 'Accesso alla fotocamera negato',
      description:
        'Consenti l\'accesso alla fotocamera nelle impostazioni del browser per continuare con la verifica.',
    },
    noCamera: {
      title: 'Nessuna fotocamera trovata',
      description: 'Assicurati che al dispositivo sia collegata una fotocamera funzionante.',
    },
    cameraError: {
      title: 'Errore fotocamera',
      description:
        'Abbiamo riscontrato un problema con la fotocamera. Controllala e riprova.',
    },
    documentFailed: {
      title: 'Acquisizione documento non riuscita',
      description:
        'Abbiamo avuto problemi ad acquisire il documento. Assicurati che ci sia buona illuminazione e riprova.',
    },
    connectionLost: {
      title: 'Connessione persa',
      description:
        'Abbiamo perso la connessione ai server. Controlla la connessione internet e riprova.',
    },
    multipleErrors: {
      title: 'Si sono verificati piu errori',
      description:
        'Stiamo riscontrando problemi persistenti. Riprova piu tardi o contatta il supporto se il problema continua.',
    },
    default: {
      title: 'Qualcosa e andato storto',
      description:
        'Abbiamo riscontrato un errore imprevisto. Riprova o ricomincia se il problema persiste.',
    },
  },
  errorState: {
    title: 'Qualcosa e andato storto',
  },
  notifications: {
    errorTitle: 'Errore',
    successTitle: 'Successo',
    infoTitle: 'Info',
    cameraAccessDenied:
      'L\'accesso alla fotocamera e stato negato. Concedi i permessi della fotocamera e riprova.',
    noCameraFound: 'Nessuna fotocamera trovata. Assicurati che il dispositivo abbia una fotocamera.',
    cameraInUse: 'La fotocamera e gia in uso da un\'altra applicazione.',
    networkError: 'Errore di rete. Controlla la connessione e riprova.',
    unexpectedError: 'Si e verificato un errore imprevisto. Riprova.',
  },
  cameraErrors: {
    notAllowed:
      'Per continuare abbiamo bisogno dell\'accesso alla fotocamera. Seleziona "Riprova" per richiederlo. Se il browser non lo chiede di nuovo, consenti l\'accesso alla fotocamera per questo sito nelle impostazioni del browser, poi riprova o ricarica la pagina.',
    notAllowedAction: 'Fai clic su Consenti quando viene richiesto l\'accesso alla fotocamera',
    security:
      'L\'accesso alla fotocamera è bloccato dalle impostazioni di sicurezza del browser o del dispositivo. Consenti l\'accesso per questo sito in tali impostazioni, quindi riprova o ricarica la pagina.',
    securityAction:
      'Consenti l\'accesso alla fotocamera nelle impostazioni di sicurezza del browser o del dispositivo',
    notFound: 'Nessuna fotocamera trovata. Assicurati che una fotocamera sia collegata.',
    notFoundAction: 'Collega un dispositivo fotocamera',
    notReadable: 'La fotocamera e gia in uso da un\'altra applicazione.',
    notReadableAction: 'Chiudi le altre applicazioni che usano la fotocamera',
    overconstrained: 'Impostazioni della fotocamera non supportate. Tentativo con impostazioni predefinite...',
    overconstrainedAction: 'Nuovo tentativo con impostazioni base della fotocamera',
    timeout: 'Timeout inizializzazione fotocamera. Riprova.',
    timeoutAction: 'Riprova',
    videoStalled:
      'La fotocamera si è accesa, ma non è arrivata alcuna immagine. Seleziona "Riprova" per riavviare la fotocamera. Se il problema persiste, chiudi le altre app che usano la fotocamera o ricarica la pagina.',
    videoStalledAction: 'Riprova per riavviare la fotocamera',
    interrupted:
      'La fotocamera si è interrotta in modo imprevisto, forse a causa di una chiamata o di un\'altra app. Seleziona "Riprova" per riavviare la fotocamera.',
    interruptedAction: 'Riprova per riavviare la fotocamera',
    initializationFailed: 'Inizializzazione della fotocamera non riuscita. Aggiorna la pagina e riprova.',
    streamUnavailable: 'Stream della fotocamera non disponibile. Controlla la connessione della fotocamera.',
    generic: 'Accesso alla fotocamera non riuscito. Controlla la fotocamera e riprova.',
    genericAction: 'Aggiorna la pagina e riprova',
  },
  brandHeader: {
    tagline: 'Verifica dell\'eta',
    merchantLabel: 'Verifica per',
    secureLabel: 'Sicuro',
  },
  faceMatchRecovery: {
    selfieRetry: {
      title: 'Proviamo con un altro selfie',
      message:
        'Questa volta non siamo riusciti ad abbinare il tuo selfie alla foto del documento. Le foto dei documenti possono essere di anni fa, e i cambiamenti nell’aspetto o nell’illuminazione possono rendere più difficile riconoscerti.',
      tipsHeading: 'Prova questi consigli per il prossimo selfie:',
      tips: {
        straightOn: 'Guarda la fotocamera di fronte e tieni tutto il viso nell’inquadratura.',
        lighting: 'Mettiti in un punto ben illuminato, con la luce davanti a te.',
        expression:
          'Prova ad avere la stessa espressione della foto del documento. Se nella foto non sorridi, mantieni un’espressione rilassata e neutra.',
        eyes: 'Assicurati che i tuoi occhi siano ben visibili, senza riflessi né occhiali da sole.',
      },
      primaryAction: 'Scatta un nuovo selfie',
      captureHeading: 'Per il tuo nuovo selfie',
      captureTips: {
        straightOn: 'Guarda la fotocamera di fronte',
        lighting: 'Luce davanti a te',
        expression: 'Stessa espressione della foto del documento',
        eyes: 'Occhi ben visibili, niente occhiali da sole',
      },
      comparing: 'Confronto del nuovo selfie con il tuo documento…',
    },
    repeated: {
      title: 'Ancora problemi? Riproviamo.',
      message:
        'Una foto del documento datata o un’illuminazione diversa possono rendere tutto più difficile. Guarda la fotocamera in un punto ben illuminato e prova ad avere la stessa espressione della foto del documento.',
      primaryAction: 'Scatta un altro selfie',
    },
    help: {
      heading: 'Serve aiuto?',
      differentIdText:
        'Se hai un altro documento d’identità con una tua foto più recente, puoi usarlo al suo posto.',
      differentIdAction: 'Usa un altro documento',
    },
    differentId: {
      captureTitle: 'Scatta una foto del tuo altro documento',
      captureInstructions:
        'Scatta una foto del fronte dell’altro documento. Assicurati che sia nitido e completamente visibile.',
    },
    retainedIdUnavailable:
      'Ci serve una nuova foto del tuo documento per completare. Assicurati che sia nitido e completamente visibile.',
  },
} as const satisfies TranslationShape;
